<div class="container">
  <mic-breadcrumb id="factory-code-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('factoryCodeText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title factory-code-heading" id="factory-code-heading">
    {{ translationService.translate('factoryCodeText') }}
  </h2>

  <div class="action-bar">
    <button id="reset-filters" type="button" mat-flat-button color="accent" class="btn-clear" (click)="clearFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>
    <button mat-flat-button color="primary" class="btn-export" (click)="openExportModal()">
      <mat-icon>download</mat-icon>
      {{ translationService.translate('exportButtonText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="factoryCode"
          formControlName="factoryCode"
          [data]="factoryCodeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('factoryCodeText') }}"
          label="{{ translationService.translate('factoryCodeText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="factoryName"
          formControlName="factoryName"
          [data]="factoryNameList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('factoryNameText') }}"
          label="{{ translationService.translate('factoryNameText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="factoryType"
          formControlName="factoryType"
          [data]="factoryTypeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('factoryTypeText') }}"
          label="{{ translationService.translate('factoryTypeText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <div id="casing-definition-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
    </mic-table>
  </div>
</div>
